<template>
  <div class="info-container" ref="info">
    <div class="info__wap-container">
       <div class="info--item"  v-for="(i,k) in shuoming" :key="k" >
        <div class="info--item__icon"> <img :src ="i.url"  /> </div>
        <div class="info--item__content">
          <div class="info--item__content__title">{{i.title}}</div>
          <div class="info--item__content__text"> {{i.text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // name: 'Info',
  mounted() {
 
},
watch:{
  
},
  data () {
    return {
      shuoming:[
        {
          url:require('../assets/wrap-img/i1.svg'),
          title:'公司简介',
          text:'成都昊雨科技有限公司成立于2014年，依循 ISO9000质量管理体系，专注于企业智能化标准体系管理软件的研发，为企业提供定制化软件服务，以及信息系统集成服务。'
        },
        {
          url:require('../assets/wrap-img/i2.svg'),
          title:'质量管理',
          text:'昊雨科技与国内知名标准体系认证中心拥有多年合作关系，致力于对ISO9000质量管理体系的钻研，将标准体系的理念贯彻于软件产品中，助力各行业轻松实现智能化质量管理。'
        },
        {
          url:require('../assets/wrap-img/i3.svg'),
          title:'定制服务（管理+软件）',
          text:'昊雨科技为国内多家机械加工、电子以及工程行业提供定制化管理软件服务。依循ISO9000标准要求，为企业进行管理流程再造，根据企业特定需求，为其量身定制软件服务，助其实现智能化质量管理。'
        }
      ],
    }
  }
}
</script>
<style scoped lang="scss"  >
@import '../assets/css/function.scss';

.wrap{
 .info-container{
  //  border:1px solid red;
   margin:0 w(24) h(40) w(24);
   
   .info--item{
    //  border:1px solid green;
     position: relative;
     margin-top:w(20);
     background: #ffffff;
     
    box-shadow: 0px 4px 4px 0px rgba(189, 189, 189, 0.26);
    border-radius: w(12);
    min-height: h(310);
     &:first-child{
        margin-top: w(-115);
     }
     .info--item__icon{
       position:absolute;
      //  border:1px solid red;
       img{
         width:w(175);
         display: block;
       }
     };
     
     .info--item__content{
      //  border:1px solid #000;
      position: relative;
       .info--item__content__title{
          font-size:f(36);
          padding-top:h(60);
          text-align: center;
          margin-bottom: h(30);
          // border:1px solid red;
       }
       .info--item__content__text{
         font-size:f(24);
        //  border:1px solid red;
         padding: 0 w(40);
         text-indent: w(70);
         letter-spacing: w(1);
        
       }
     }
   }
 }
}

</style>



// WEBPACK FOOTER //
// src/components/Info.vue